import { useSiteStore } from "../stores/siteStore";

/** Active warehouse — undefined when the user hasn't picked one yet
 *  or when no warehouse data is available. */
export function useWarehouseId(): string | undefined {
  return useSiteStore((s) => s.activeWarehouseId);
}
